<template>
  <div class="bg-pink-400 head">
    <div class="carousel-container" >
      <img
        class="carousel_transform"
        :class="{ 'carousel_transform--loaded': bannerLoaded }"
        :src="banner"
        loading="lazy"
        decoding="async"
        @load="bannerLoaded = true"
        alt=""
      >
    </div>
  </div>
</template>

<script>
// 模板已简化为仅展示横幅，原门户语言/搜索等图标不再使用
import banner from "../../assets/TopBar/banner.jpg";

export default {
  name: "AppHeader",
  inject: ["reload"],
  data() {
    return {
      style: true,
      bannerLoaded: false,
      SearchShow: false,
      Searchinput: "",
      advancedsearch: {
        currentPage: "1",
        limitHight: "10",
        dateType: "1",
        format: "0",
        keyword: "",
      },
      SearchList: null,
      loading: false,
      navList: [],
      locale: "zh",
      inceptionNavi: {},
      showTowNav: false,
      menuOpen: false,
      jsonData: {},

      banner,
    };
  },
  watch: {
    $route(to, from) {
      console.log("监听到路由变化", to, from);

      // 路由变化时执行的操作
      if (to.path === "/" || to.path === "/aboutIndex" || to.path === "/Scenicspot") {
        this.style = true;
      } else {
        this.style = false;
      }
    },
  },
  mounted() {
    // 初始化语言
    if (this.locale === "") {
      this.locale = "zh";
    }
    // 启动定时器更新时间（每秒）
    //   this.timeInterval = setInterval(() => {
    //     this.$forceUpdate(); // 强制更新以刷新时间显示
    //   }, 1000);
  },
  beforeDestroy() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  },
  methods: {
    getCurrentTime() {
      // 使用 dayjs 格式化当前时间，需要确保 dayjs 已挂载到 Vue 原型或直接导入
      // 假设在 main.js 中已经将 dayjs 挂载到 Vue.prototype.$dayjs
      return this.$dayjs(new Date()).format("MM-DD HH:mm:ss");
    },
    setSearch() {
      this.SearchShow = !this.SearchShow;
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      if (this.SearchShow) {
        this.SearchShow = false;
        console.log("点击了区域外，关闭菜单");
      }
    },
    mouseenter(item, index) {
      if (index === 0) {
        this.showTowNav = false;
        return;
      }
      this.inceptionNavi = item;
      this.showTowNav = true;
    },
    mouseleave() {
      this.showTowNav = false;
    },
    toggleLanguage() {
      const newLang = this.locale === "zh" ? "en" : "zh";
      this.locale = newLang;
      localStorage.setItem("lang", newLang);
      const site = this.locale === "zh" ? 0 : 1;
      localStorage.setItem("site", String(site));
      // 触发页面刷新
      this.reload();
    },
    toLink(item) {
      this.$router.push({ path: item.link, query: { code: item.code } });
    },
  },
};
</script>

<style scoped lang="scss">
.head {}
/* 轮播图动画 */
@keyframes imgmove {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}

.carousel-container {
  width: 100%;
  overflow: hidden;
  background: #f5f0eb;
  // min-height: 200px;
}

.carousel_transform {
  width: 100%;
  display: block;
  opacity: 0;
  transition: opacity 0.6s ease;
}

.carousel_transform--loaded {
  opacity: 1;
  animation: imgmove 8s infinite;
  transform-origin: center center;
}
</style>
